import { Doughnut } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js'; 
import 'chartjs-adapter-date-fns';

Chart.register(...registerables);

function DonutChart({ totalBins, filledBinsCount }) {
  const unfilledBinsCount = totalBins - filledBinsCount;

  const chartData = {
    labels: ['Total Bins', 'Filled Bins', 'Unfilled Bins'],
    datasets: [
      {
        data: [totalBins, filledBinsCount, unfilledBinsCount],
        backgroundColor: ['rgba(211, 109, 87, 0.7)', 'rgba(211, 109, 87, 0.5)', 'rgba(211, 109, 87, 0.3)'],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        color: '#fff',
        formatter: (value, context) => {
          return context.chart.data.labels[context.dataIndex];
        },
      },
    },
    cutout: '70%',
  };

  return <Doughnut data={chartData} options={options} />;
}

export default DonutChart;
